import { useEffect, useRef, useState } from "react";
import { toast } from "sonner";
import { Layers, Loader2 } from "lucide-react";
import { http, errMsg } from "../../lib/api";

export const FillPagesButton = ({ kit, reload, disabled }) => {
  const [starting, setStarting] = useState(false);
  const was = useRef(kit.filling);
  const filling = starting || kit.filling;

  useEffect(() => {
    if (was.current && !kit.filling) {
      const r = kit.fill_result || {};
      if (r.error) toast.error(`Fill pages failed: ${r.error}`);
      else if (r.plan) (r.fill_left.length || r.fit_left.length) ? toast.warning(`Choices done. Still not right: ${r.fill_left.length} page(s) to fill, ${r.fit_left.length} spill(s) to fit — choose again on the Page check tab.`) : toast.success("All your page choices are done");
      else if (r.fit_block) r.fit_ok ? toast.success("That page now fits on one page") : toast.warning("Shortened, but it still runs onto a second page after 4 tries. Try again, trim it by hand, or Allow 2 pages.");
      else if (r.overflow) toast.warning(`Pages filled. ${r.overflow} block(s) spill onto a second page — choose Allow 2 pages or Fit to 1 page for each on the Page check tab.${r.light_pages ? ` ${r.light_pages} page(s) under 85%.` : ""}`);
      else if (r.light_pages) toast.warning(`Pages filled — ${r.light_pages} page(s) still under 85%. Run again or add text manually.`);
      else toast.success("All pages now meet the 85% fill rule");
    }
    was.current = kit.filling;
  }, [kit.filling, kit.fill_result]);

  const go = async () => {
    setStarting(true);
    try {
      await http.post(`/kits/${kit.id}/fill-pages`);
      toast.message("Topping up light pages — this takes a few minutes");
      was.current = true;
      await reload();
    } catch (e) { toast.error(errMsg(e)); }
    setStarting(false);
  };

  return (
    <button data-testid="fill-pages-button" onClick={go} disabled={disabled || filling}
      title="Expand any page under 85% full (spill pages are left for you to decide)"
      className="inline-flex items-center gap-2 rounded-sm border border-stone-300 px-4 py-2 text-sm text-stone-600 hover:text-stone-900 hover:bg-stone-100 transition-colors disabled:opacity-40">
      {filling ? <Loader2 size={15} className="animate-spin" /> : <Layers size={15} />}
      {filling ? <span data-testid="fill-pages-progress">{kit.progress?.current || "Filling pages…"}</span> : "Fill pages"}
    </button>
  );
};
